import { AppData, Lightning } from '@lightningjs/sdk';
import SettingsToggleSection from './SettingsToggleSection';
import ToggleContent from 'components/pages/settings/sections/contents/ToggleContent';

export interface PlaybackSettingsSectionTemplateSpec
  extends Lightning.Component.TemplateSpec {
  Content: {
    AutoplayContent: typeof ToggleContent;
    Toggle: typeof SettingsToggleSection;
  };
}

export default class PlaybackSettingsSection
  extends Lightning.Component<PlaybackSettingsSectionTemplateSpec>
  implements
    Lightning.Component
      .ImplementTemplateSpec<PlaybackSettingsSectionTemplateSpec>
{
  private _Content = this.getByRef('Content')!;
  private _AutoplayContent = this._Content.getByRef('AutoplayContent')!;
  private _Toggle = this._Content.getByRef('Toggle')!;
  private _ToggleButtons = this._Toggle.getByRef('ToggleButtons')!;

  get title() {
    const autoplayContent = this._AutoplayContent.title;
    return [...autoplayContent];
  }

  static override _template(): Lightning.Component.Template<PlaybackSettingsSectionTemplateSpec> {
    return {
      Content: {
        flex: { direction: 'column' },
        AutoplayContent: { type: ToggleContent },
        Toggle: {
          type: SettingsToggleSection,
          selectedIndex: this.shouldAutoplay() ? 0 : 1,
          signals: {
            onChanged: '_onAutoplaySettingsChanged',
          },
        },
      },
    };
  }

  override _active() {
    const autoplayContent =
      AppData!.config?.login.settings.playback_settings.autoplay_settings;
    if (!autoplayContent) return;

    this._AutoplayContent.heading = autoplayContent.title ?? '';
    this._AutoplayContent.description = autoplayContent.description ?? '';
  }

  override _getFocused() {
    return this._ToggleButtons;
  }

  private static shouldAutoplay() {
    return AppData!.storageService.shouldAutoplay();
  }

  private _onAutoplaySettingsChanged(autoplay: boolean) {
    AppData!.storageService.autoplaySettings.set(autoplay);
  }
}
